<template>
  <div>
    <v-card>
      <v-card-title>
        <span v-if="showTitle">Payroll Location</span>
        <div class="flex-grow-1"></div>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-container v-if="showDense">
          <v-row>
            <v-col>
              <v-checkbox label="Dense" v-model="dense"></v-checkbox>
            </v-col>
          </v-row>
        </v-container>

        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
          :footer-props="footerProps"
          :search="search"
          :dense="dense"
          item-key="locId"
          :show-select="showSelect"
          text="Loading... Please wait"
          v-model="selected"
        >
          <!-- <template slot="items" slot-scope="props">
            <td v-for="(header, index) in headers" :key="index">
              <span>{{ props.item[header.value] }}</span>
            </td>
          </template>-->
          <template v-slot:item.annualized="{ item }">
            <span>{{ item.annualized }}</span>
          </template>
          <template v-slot:item.payCode="{ item }">
            <span>{{ item.payCode | payrollType }}</span>
          </template>
          <template v-slot:item.rateCode="{ item }">
            <span>{{ item.rateCode | taxRate }}</span>
          </template>
          <template v-slot:item.action="{ item }">
            <slot name="actions" v-bind:item="item"></slot>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
const API_ENDPOINT = "/api/payrollLocation";
import EventBus from "../../../../events/eventBus";
export default {
  props: {
    showTitle: {
      default: true,
      type: Boolean
    },
    showDense: {
      default: true,
      type: Boolean
    },
    headers: {
      default: () => [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "action"
        },
        {
          text: "Loc Id",
          align: "left",
          //sortable: false,
          value: "locId"
        },
        {
          text: "Location Name",
          align: "left",
          //sortable: false,
          value: "locName"
        },
        {
          text: "Payroll Type",
          align: "left",
          //sortable: false,
          value: "payCode"
        },
        {
          text: "Tax Rate",
          align: "left",
          //sortable: false,
          value: "rateCode"
        },
        {
          text: "No. of Days",
          align: "left",
          //sortable: false,
          value: "noOfDays"
        },
        {
          text: "No. of Hours",
          align: "left",
          //sortable: false,
          value: "hrsInADay"
        },
        {
          text: "Total Period",
          align: "left",
          //sortable: false,
          value: "totalPeriod"
        },
        {
          text: "W Tax Contri",
          align: "left",
          //sortable: false,
          value: "contribPayPer"
        },
        {
          text: "W Tax Contri",
          align: "left",
          //sortable: false,
          value: "contribPayPer"
        },
        {
          text: "Annualized",
          align: "left",
          //sortable: false,
          value: "annualized"
        },
        {
          text: "Allowance/Insurance Period",
          align: "left",
          //sortable: false,
          value: "insPayPer"
        },
        {
          text: "SSS Period",
          align: "left",
          //sortable: false,
          value: "sssPayPer"
        },
        {
          text: "SSS Period",
          align: "left",
          //sortable: false,
          value: "sssPayPer"
        },
        {
          text: "Pagibig Period",
          align: "left",
          //sortable: false,
          value: "pagPayPer"
        },
        {
          text: "PhilHealth Period",
          align: "left",
          //sortable: false,
          value: "philPayPer"
        },
        {
          text: "Noted By",
          align: "left",
          //sortable: false,
          value: "notedByName"
        },
        {
          text: "Prepared By",
          align: "left",
          //sortable: false,
          value: "preparedByName"
        },
        {
          text: "Reviewed By",
          align: "left",
          //sortable: false,
          value: "reviewedByName"
        },
        {
          text: "Approved By",
          align: "left",
          //sortable: false,
          value: "approvedByName"
        }
      ],
      type: Array
    },
    showSelect: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    items: [],
    search: "",
    footerProps: {
      rowsPerPageItems: [10, 25, 50, 100]
    },
    loading: false,
    dense: false,
    selected: []
  }),
  computed: {
    filteredItems() {
      return this.filterItems(this.items, this.search);
    }
  },
  methods: {
    getAll() {
      this.$axios
        .get(`${API_ENDPOINT}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    selectedChanged(val) {
      EventBus.$emit("SELECTED_PAYLOC", Object.assign([], val));
    },
    filterItems(items, query) {
      var filtered = items.filter(item => {
        // let locId = item.locId.toLowerCase().includes(query.toLowerCase());
        let locName = item.locName.toLowerCase().includes(query.toLowerCase());
        return locName;
      });

      return filtered;
    }
  },
  created() {
    this.getAll();
  },
  mounted() {
    // this.getAll();

    EventBus.$on("TOGGLE_SELECTED_PAYLOC", payload => {
      this.selected = payload;
    });
  },
  watch: {
    selected(val) {
      this.selectedChanged(val);
    },
    search(val) {
      this.filterItems(this.items, val);
    }
  }
};
</script>
